import { Box, LinearProgress } from '@mui/material';

export function Loader() {
  return (
    <Box sx={{ position: 'fixed', top: 0, left: 0, zIndex: 1301, width: '100%' }}>
      <LinearProgress color='primary' />
    </Box>
  );
}
